import { render, staticRenderFns } from "./ConfirmRemoveDialog.vue?vue&type=template&id=c125fe9e"
import script from "./ConfirmRemoveDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmRemoveDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports